import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_DIPARTIMENTO } from '../../data.const';
import {
  retrieveDipartimentoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteDipartimentoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_DIPARTIMENTO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        defer(() =>
          from(
            request({
              path: `dipartimento`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveDipartimentoListAction(null))),
            catchError(err => {
              console.error(`[epic ${DELETE_DIPARTIMENTO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default deleteDipartimentoEpic;
